export const fieldTypes = [
    { type: "TextField", hint: "A simple text field", keepItSimple: true, defaultName: "Text Field" },
    {
        type: "MultipleLinesText",
        hint: "A multiline text field",
        keepItSimple: false,
        defaultName: "Multiple Lines Text",
        constrains: {
            minLength: {
                fieldPrimaryType: "NumberField",
                hint: "Minimum number of characters required",
                designerLimit: 0,
            },
            maxLength: {
                fieldPrimaryType: "NumberField",
                hint: "Maximum number of characters allowed",
                designerLimit: 500,
            },
            minRows: {
                fieldPrimaryType: "NumberField",
                hint: "Minimum number of visible rows",
                designerLimit: 3,
            },
            maxRows: {
                fieldPrimaryType: "NumberField",
                hint: "Maximum number of visible rows",
                designerLimit: 10,
            },
        },
    },
    { type: "NumberField", hint: "A field for numbers", keepItSimple: true, defaultName: "Number Field" },
    { type: "Image Picker", hint: "A field to pick images", keepItSimple: true, defaultName: "Image Picker" },
    {
        type: "Profile Image Picker",
        keepItSimple: false,
        defaultName: "Profile Image Picker",
        options: {
            cameraCapture: true,
            storeImageInDB: false,
            storeFacePattern: true,
            DownSizeToConstrains: false,
        },
        constrains: {
            imagePixelDimensionlimit: {
                fieldPrimaryType: "TextField",
                hint: "for example 300x300"
            },
            sizeLimit: {
                fieldPrimaryType: "NumberField",
                hint: "Define maximum allowed image size",
                designerLimit: "5MB"
            },
            accept: {
                fieldPrimaryType: "TextField",
                hint: "image extension like .jpg,.png,.icon,... or * for all",
                regexPattern: "(:?\\*)|(:?(:?\\.\\w+)(:?,\\.\\w+)*)",
                designDefault: "*"
            }
        }
    },
    { type: "Name", hint: "Name of the person", keepItSimple: false, defaultName: "Name" },
    { type: "Age", hint: "Age of the person", keepItSimple: false, defaultName: "Age" },
    { type: "Birthdate Picker", hint: "Birthdate of the person", keepItSimple: false, defaultName: "Birthdate Picker" },
    { type: "Map address", hint: "Address of the person on the map for example latitude and longitude", keepItSimple: false, defaultName: "Map Address" },
    { type: "Email", hint: "Email address of the person", keepItSimple: false, defaultName: "Email" },
    { type: "Phone number", hint: "Phone number of the person", keepItSimple: false, defaultName: "Phone Number" },
    {
        type: "Comments",
        hint: "Allow users to add multiple comments with automatic username and timestamp",
        keepItSimple: false,
        defaultName: "Comments",
        options: {
            username: "Anonymous",
        },
        constrains: {
            minComments: {
                fieldPrimaryType: "NumberField",
                hint: "Minimum number of comments required",
                designerLimit: 0,
            },
            maxComments: {
                fieldPrimaryType: "NumberField",
                hint: "Maximum number of comments allowed",
                designerLimit: 50,
            },
            maxCommentLength: {
                fieldPrimaryType: "NumberField",
                hint: "Maximum length of each comment",
                designerLimit: 500,
            },
        },
    },
    {
        type: "Custom Note",
        hint: "A flexible field that can contain other fields",
        keepItSimple: false,
        defaultName: "Custom Note",
        options: {
            allowMultipleFields: true,
        },
        constrains: {
            maxFields: {
                fieldPrimaryType: "NumberField",
                hint: "Maximum number of fields allowed",
                designerLimit: 10,
            },
        },
    },
    {
        type: "Radio Button",
        hint: "A field with radio button options",
        keepItSimple: false,
        defaultName: "Radio Button",
        options: {
            row: false,
            options: ["Option 1", "Option 2", "Option 3"],
        },
        constrains: {
            minOptions: {
                fieldPrimaryType: "NumberField",
                hint: "Minimum number of options required",
                designerLimit: 2,
            },
            maxOptions: {
                fieldPrimaryType: "NumberField",
                hint: "Maximum number of options allowed",
                designerLimit: 10,
            },
        },
    },
    {
        type: "CheckBox",
        hint: "A field with multiple checkbox options (can select multiple)",
        keepItSimple: false,
        defaultName: "CheckBox",
        options: {
            options: ["Option 1", "Option 2", "Option 3"],
        },
        constrains: {
            minOptions: {
                fieldPrimaryType: "NumberField",
                hint: "Minimum number of options required",
                designerLimit: 1,
            },
            maxOptions: {
                fieldPrimaryType: "NumberField",
                hint: "Maximum number of options allowed",
                designerLimit: 20,
            },
            minSelections: {
                fieldPrimaryType: "NumberField",
                hint: "Minimum number of selections required",
                designerLimit: 0,
            },
            maxSelections: {
                fieldPrimaryType: "NumberField",
                hint: "Maximum number of selections allowed",
                designerLimit: 10,
            },
        },
    },
    {
        type: "Dropdown Menu",
        hint: "A dropdown menu with selectable options",
        keepItSimple: false,
        defaultName: "Dropdown Menu",
        options: {
            options: ["Option 1", "Option 2", "Option 3"],
        },
        constrains: {
            minOptions: {
                fieldPrimaryType: "NumberField",
                hint: "Minimum number of options required",
                designerLimit: 1,
            },
            maxOptions: {
                fieldPrimaryType: "NumberField",
                hint: "Maximum number of options allowed",
                designerLimit: 20,
            },
        },
    },
    {
        type: "Autocomplete",
        hint: "Autocomplete field with support for static options or database column values",
        keepItSimple: false,
        defaultName: "Autocomplete",
        options: {
            multiple: false,
            freeSolo: false,
            staticOptions: [],
            smartAutocomplete: true,
            useDatabase: false,
            databaseName: "",
            dbGroupName: "",
            columnName: "",
            uniqueOnly: true,
            sortAscending: true,
        },
        constrains: {
            maxLength: {
                fieldPrimaryType: "NumberField",
                hint: "Maximum length for custom values (freeSolo mode)",
                designerLimit: 100,
            },
            minOptions: {
                fieldPrimaryType: "NumberField",
                hint: "Minimum number of selections (for multiple mode)",
                designerLimit: 0,
            },
            maxOptions: {
                fieldPrimaryType: "NumberField",
                hint: "Maximum number of selections (for multiple mode)",
                designerLimit: 10,
            },
        },
    },
    {
        type: "Glass Over Image",
        hint: "Draw on top of an image using Canvas (simple and fast)",
        keepItSimple: false,
        defaultName: "Glass Over Image",
        options: {
            strokeColor: "#FF0000",
            strokeWidth: 3,
        },
        constrains: {
            maxFileSize: {
                fieldPrimaryType: "NumberField",
                hint: "Maximum image file size in MB",
                designerLimit: 5,
            },
        },
    },
    {
        type: "Glass Over Image SVG",
        hint: "Draw on top of an image using SVG (scalable vector graphics)",
        keepItSimple: false,
        defaultName: "Glass Over Image SVG",
        options: {
            strokeColor: "#FF0000",
            strokeWidth: 3,
        },
        constrains: {
            maxFileSize: {
                fieldPrimaryType: "NumberField",
                hint: "Maximum image file size in MB",
                designerLimit: 5,
            },
        },
    },
    {
        type: "Glass Over Image Advanced",
        hint: "Advanced drawing with colors, brush sizes, eraser, and undo/redo",
        keepItSimple: false,
        defaultName: "Glass Over Image Advanced",
        options: {
            strokeColor: "#FF0000",
            strokeWidth: 3,
            enableEraser: true,
            enableColorPicker: true,
        },
        constrains: {
            maxFileSize: {
                fieldPrimaryType: "NumberField",
                hint: "Maximum image file size in MB",
                designerLimit: 5,
            },
        },
    },
];
